import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Expander from '@starbucks-web/pattern-library/lib/components/expander';
import Field from '@starbucks-web/pattern-library/lib/components/field';
import shouldDisplayError from '@starbucks-web/pattern-library/lib/components/form-container/should-display-error';
import Icon from '@starbucks-web/pattern-library/lib/components/icon';
import cautionSolidIconPath from '@starbucks-web/pattern-library/lib/icons/caution-solid';

import Alert from '../alert';
import Frap from 'shared/app/components/frap-with-messages';
import FrapContainer from 'shared/app/components/frap-container';
import PasswordField from 'shared/app/components/password-field';
import { prefixErrorMessage } from 'shared/app/components/a11y-error-message-prefix';

import ForgotUsernameLink from '../forgot-username-link';
import KeepMeSignedIn from '../keep-me-signed-in';

import { sharedCallsToAction, accountsMessages } from 'shared/app/messages';

import messages from './messages';

const SignInFields = ({
  errorHeading,
  errorMessage,
  fields,
  isFetching,
  showErrorMessage = false,
  updatedTermsOfUseUrl,
}) => {
  const termsOfUseLink = updatedTermsOfUseUrl && (
    <a className="color-greenStarbucks" href={updatedTermsOfUseUrl}>
      <FormattedMessage {...accountsMessages.termsOfUse} />
    </a>
  );

  return (
    <React.Fragment>
      <Expander isExpanded={showErrorMessage}>
        <Alert errorHeading={errorHeading} errorMessage={errorMessage} />
      </Expander>

      <Field
        {...fields.username.input}
        autoComplete="email"
        autoCorrect="off"
        className="mt3 mb2"
        data-e2e="username"
        error={shouldDisplayError(fields.username)}
        errorMessage={prefixErrorMessage(messages.usernameError)}
        type="email"
      >
        <FormattedMessage {...messages.usernameLabel} />
      </Field>
      <PasswordField
        {...fields.password.input}
        autoComplete="current-password"
        className="mb3"
        error={shouldDisplayError(fields.password)}
        errorMessage={prefixErrorMessage(messages.passwordError)}
      >
        <FormattedMessage {...accountsMessages.password} />
      </PasswordField>

      <KeepMeSignedIn fields={fields} />

      <ForgotUsernameLink />

      <p className="mb3 text-bold text-xs">
        <Link
          className="color-greenStarbucks"
          data-e2e="forgotPasswordLink"
          to="/account/forgot-password"
        >
          <FormattedMessage {...accountsMessages.forgotYourPassword} />
        </Link>
      </p>

      {updatedTermsOfUseUrl && (
        <p className="mb4">
          <span className="mr2">
            <Icon
              className="color-yellow"
              path={cautionSolidIconPath}
              size="24px"
            />
          </span>
          <FormattedMessage
            {...messages.updatedTermsOfUse}
            values={{ termsOfUseLink }}
          />
        </p>
      )}

      <FrapContainer relativeAbove="alwaysRelative">
        <Frap data-e2e="signInButton" loading={isFetching} type="submit">
          <FormattedMessage {...sharedCallsToAction.signin} />
        </Frap>
      </FrapContainer>
    </React.Fragment>
  );
};

SignInFields.propTypes = {
  errorHeading: PropTypes.string,
  errorMessage: PropTypes.string,
  fields: PropTypes.object,
  isFetching: PropTypes.bool,
  showErrorMessage: PropTypes.bool.isRequired,
  updatedTermsOfUseUrl: PropTypes.string,
};

export default SignInFields;
